export type IGetNameOfClassStartingWith = (classString: string, startsWith: string) => string;

export function getNameOfClassStartingWith(classString: string, startsWith: string): string {
  const classArray: string[] = classString.split(' ');
  for (const cls of classArray) {
    if (cls.startsWith(startsWith)) {
      return cls;
    }
  }
  console.warn('Warning: class name not found!');
  return '';
}
